"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteMobileModalWrapper = exports.TriggerInput = exports.LoadMoreButton = exports.AutocompleteMoreButtonWrap = exports.AutocompleteSuggestionItem = exports.SuggestionListBox = exports.AutocompleteSuggestionsWrap = exports.AutocompleteInputWrap = exports.RemoveButton = exports.AutocompleteTagWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const components_common_modals_1 = require("@hotelplan/components.common.modals");
exports.AutocompleteTagWrap = styled_components_1.default.div(({ theme }) => theme.autocomplete.tagWrap, ({ theme, active }) => active
    ? {
        borderColor: theme.colors.accentColor,
    }
    : {});
exports.RemoveButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)(({ theme }) => theme.autocomplete.autocompleteRemoveButtonStyles);
exports.AutocompleteInputWrap = styled_components_1.default.div(({ theme }) => theme.autocomplete.inputWrapStyles);
exports.AutocompleteSuggestionsWrap = styled_components_1.default.div({ display: 'flex' }, ({ theme }) => theme.autocomplete.tagBlock, ({ theme: { media } }) => ({
    maxHeight: '100%',
    [media.tablet]: {
        maxHeight: '540px',
    },
}));
exports.SuggestionListBox = styled_components_1.default.ul(({ theme }) => theme.autocomplete.suggestionListStyles);
exports.AutocompleteSuggestionItem = styled_components_1.default.li(({ active }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    cursor: [null, `pointer`],
    py: [1, 2],
    outline: '1px transparent dotted',
    outlineColor: active ? 'accentColor' : 'transparent',
}));
exports.AutocompleteMoreButtonWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    pb: [4, 2],
    textAlign: 'right',
}));
exports.LoadMoreButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton).attrs({
    variant: 'linkBtn',
    'data-id': `load-more`,
})(({ theme }) => {
    var _a;
    return (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ color: 'primary', marginLeft: 'auto' }, (((_a = theme.autocomplete) === null || _a === void 0 ? void 0 : _a.loadMoreButton) || {})));
});
exports.TriggerInput = (0, styled_components_1.default)(components_common_inputs_1.BaseInput)((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.icon': {
        variant: ['icons.md', 'icons.lg'],
    },
    input: {
        pr: [null, '10px'],
    },
}));
exports.AutocompleteMobileModalWrapper = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal)(({ theme }) => theme.autocomplete.mobileModal);
//# sourceMappingURL=fdr-combobox.styles.js.map